let inject = ['$q', '$http', 'ngAuthSettings', '$httpParamSerializerJQLike', 'SessionService'];

class CatalogService {
    constructor($q, $http, ngAuthSettings, $httpParamSerializerJQLike, SessionService) {
        this.ngAuthSettings = ngAuthSettings;
        this.$httpParamSerializerJQLike = $httpParamSerializerJQLike;
        this.SessionService = SessionService;
        this.$q = $q;
        this.$http = $http;
    }

    getFeaturedProducts(userId, limit) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.featuredProducts + '?userId=' + userId + '&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getRelatedProducts(productId, userId, limit) {
        let cartId = this.SessionService.get('cartId') || '';
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.relatedProducts +
                    productId + '&userId=' + userId + '&cartId=' + cartId +'&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getRelatedCategoryProducts(productId, userId, limit, categoryId) {
        let cartId = this.SessionService.get('cartId') || '';
        return this.$q((resolve, reject) => {

            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.relatedCategoryProducts +
                    productId + '&cartId=' + cartId + '&userId=' + userId + '&limit=' + limit + '&categoryId=' + categoryId,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getNewProducts(userId, limit) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.newItems + '?userId=' + userId + '&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getMostSelledProducts(userId, limit) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.bestSellerItems + '?userId=' + userId + '&limit=' + limit,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    updateFavoriteProducts(data) {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'POST',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.setFavoriteProduct,
                cache: true,
                headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                data: this.$httpParamSerializerJQLike(data)
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }


    getProducts(userId, limit, type, categoryId = '', itemId = '',categoryIdFilter='',origin = '') {
        let cartId = this.SessionService.get('cartId') || '';
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri +
                    this.ngAuthSettings.config.paths.boxItems + '?userId=' + userId + '&limit=' +
                    limit + '&type=' + type + '&itemId='
                    + itemId + '&categoryId=' + categoryId + '&cartId=' + cartId,
                cache: false
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

    getFeaturedCategories() {
        return this.$q((resolve, reject) => {
            this.$http({
                method: 'GET',
                url: this.ngAuthSettings.apiServiceBaseUri + this.ngAuthSettings.config.paths.categoryFeatured,
                cache: true
            }).then((response) => {
                resolve(response.data);
            }, (reason) => {
                reject(reason);
            });
        });
    }

}

CatalogService.$inject = inject;

export default CatalogService;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/catalog.service.js
 **/